import Vue from 'vue';
import Notifications from '~notify/Notify.vue';

/* eslint-disable no-unused-expressions,no-use-before-define,brace-style */

class Notify {
    constructor(options) {
        this.options = options;
        this.__vm = new Vue(Notifications);
        this.create = function(opts) {
            return this.__vm.add(opts, this.options);
        };
        this.create.bind(this)
        this.registerType = function(typeName, typeOpts) {
            this.options.types[typeName] = typeOpts;
        };
    }
}

export default function({app}, inject) {
    const options = {"types":{"positive":{"icon":function() {
        return 'success';
      },"color":"positive","position":"top-right","actions":[{"color":"transparent","icon":true,"hover":false,"iconName":"close","small":true}]},"negative":{"icon":function() {
        return 'errorFilled';
      },"color":"negative","position":"top-right","timeout":3000,"actions":[{"color":"transparent","icon":true,"hover":false,"iconName":"close","small":true}]},"warning":{"icon":function() {
        return 'error';
      },"color":"warning","position":"top-right","actions":[{"color":"transparent","icon":true,"hover":false,"iconName":"close","small":true}]},"info":{"icon":function() {
        return 'notification';
      },"type":"info","color":"info","position":"top-right","actions":[{"color":"vice","icon":true,"iconName":"close","small":true}]},"ongoing":{"group":false,"timeout":3000,"spinner":true,"color":"grey-8"}}};
    const notifyPlugin = new Notify(options);
    app.$notify = notifyPlugin;
    inject('notify', notifyPlugin);
    if (!app.mixins) {
        app.mixins = [];
    }
    app.mixins.push({
        mounted() {
            const node = document.createElement('div');
            document.body.appendChild(node);
            notifyPlugin.__vm.$mount(node);
        },
    });
}
